import { VIEW } from '@/types/widget';
import { WidgetStoreSliceCreator } from '../types';

export interface InterfaceStore {
  interface: {
    // State
    widgetIsOpen: boolean;
    widgetActiveView: VIEW;
    isInlineMode: boolean;
    // Actions
    setWidgetActiveView: (view: VIEW) => void;
    toggleWidgetOpen: () => void;
    setWidgetIsOpen: (widgetIsOpen: boolean) => void;
    setIsInlineMode: (isInlineMode: boolean) => void;
  };
}

export const createInterfaceSlice: WidgetStoreSliceCreator<
  InterfaceStore
> = set => ({
  interface: {
    // State
    widgetIsOpen: false,
    widgetActiveView: VIEW.CHAT,
    isInlineMode: false,
    // Actions
    toggleWidgetOpen: () =>
      set(state => {
        return {
          interface: {
            ...state.interface,
            widgetIsOpen: !state.interface.widgetIsOpen,
          },
        };
      }),
    setWidgetIsOpen: (widgetIsOpen: boolean) =>
      set(state => ({
        interface: {
          ...state.interface,
          widgetIsOpen,
        },
      })),
    setWidgetActiveView: (widgetActiveView: VIEW) =>
      set(state => ({
        interface: {
          ...state.interface,
          widgetActiveView,
        },
      })),
    setIsInlineMode: (isInlineMode: boolean) =>
      set(state => ({
        interface: {
          ...state.interface,
          isInlineMode,
        },
      })),
  },
});
